'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render"];
import * as React from 'react';
import { useRenderElement } from '@mui/x-scheduler-headless/base-ui-copy';
export const TimelineGridRow = /*#__PURE__*/React.forwardRef(function TimelineGridRow(componentProps, forwardedRef) {
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // TODO: Add aria-rowindex using Composite.
  const props = {
    role: 'row'
  };
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [props, elementProps]
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridRow.displayName = "TimelineGridRow";